const USER_TITLE = {
    mister: 'Monsieur',
    missus: 'Madame',
};

function Brevo() {
    if ('Brevo' in window) {
        return window.Brevo;
    }
    return null;
}

/**
 * @param {Object} user
 * @param {boolean=true} withEmail
 * @return {{FIRSTNAME: string, LASTNAME: string, CIVILITE: string, ANNIVERSAIRE: string|null, CODE_POSTAL: string, VILLE: string}}
 */
function userProperties(user, withEmail = true) {
    const properties = {
        FIRSTNAME: user.firstName,
        LASTNAME: user.lastName,
        CIVILITE: USER_TITLE[user.title],
        ANNIVERSAIRE: user.birthDate ? formatDate(new Date(user.birthDate * 1000)) : null,
        CODE_POSTAL: user.postalCode,
        VILLE: user.city,
    };
    if (withEmail) {
        properties.EMAIL = user.email;
    }
    return properties;
}

/**
 * @param {Date} date
 * @return {string}
 */
function formatDate(date) {
    return [
        date.getFullYear(),
        (date.getMonth() + 1).toString().padStart(2, '0'),
        date.getDate().toString().padStart(2, '0'),
    ].join('-');
}

export function updateCart(data) {
    if (!data.user) {
        return;
    }

    const items = data.items.map(item => ({
        image: item.fullMainImageUrl,
        name: item.name,
        price: item.price,
        category: item.category,
        size: item.size,
        url: item.fullDetailUrl,
    }));

    Brevo()?.track('cart_updated', userProperties(data.user), {data: {items}});
}

export function identify(user) {
    if (!user) {
        return;
    }
    Brevo()?.identify(user.email, userProperties(user, false));
}

export function orderCompleted() {
    Brevo()?.track('order_completed');
}

export function cartDeleted() {
    Brevo()?.track('cart_deleted');
}
